import { render } from "./unclodesTickets.vue?vue&type=template&id=59586086"
import script from "./unclodesTickets.vue?vue&type=script&lang=js"
export * from "./unclodesTickets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__